export const breakpoints = [1100, 1366, 1600, 1920];

export const breakpointsMap = {
  small: breakpoints[0],
  medium: breakpoints[1],
  large: breakpoints[2],
  xlarge: breakpoints[3],
};
